
// This file is generated by the maven plugin com.axley.js-remodel.  Do not edit!!!

export class GenMetricSource {
    static readonly NTL: GenMetricSource = new GenMetricSource('NTL');
    static readonly TASTIGRID: GenMetricSource = new GenMetricSource('TASTIGRID');

    public readonly name: string;

    private constructor(name: string) {
        this.name = name;
    }

    static forName(name: string) {
        if (name === 'NTL') return GenMetricSource.NTL;
        if (name === 'TASTIGRID') return GenMetricSource.TASTIGRID;
        throw new Error('Unexpected value for GenMetricSource:' + name);
    }

    static values(): GenMetricSource[] {
        return [
            GenMetricSource.NTL,
            GenMetricSource.TASTIGRID,
        ];
    }

    toJSON(): string {
        return this.name;
    }

    toString(): string {
        return this.name;
    }
}

